export type CampaignMarketingFieldErrors = {
  fb_pixel?: string
  g_pixel?: string
  gtm_measurement_id?: string
  fb_access_token?: string
  ga4_measurement_protocol_secret?: string
}

export function validateCampaignMarketingFields(input: {
  fb_pixel?: string
  g_pixel?: string
  gtm_measurement_id?: string
  ga4_measurement_protocol_secret?: string
}): CampaignMarketingFieldErrors {
  const errors: CampaignMarketingFieldErrors = {}

  const gPixel = (input.g_pixel ?? '').trim()
  if (gPixel !== '' && !/^GTM-[A-Za-z0-9_-]+$/i.test(gPixel)) {
    errors.g_pixel = 'Google Tag Manager deve estar no formato GTM-XXXXXX.'
  }

  const ga4Id = (input.gtm_measurement_id ?? '').trim().toUpperCase()
  if (ga4Id !== '' && !/^G-[A-Z0-9]+$/.test(ga4Id)) {
    errors.gtm_measurement_id = 'ID de medição GA4 deve estar no formato G-XXXXXXXXXX.'
  }

  const ga4Secret = (input.ga4_measurement_protocol_secret ?? '').trim()
  if (ga4Secret !== '' && !/^[A-Za-z0-9_-]{8,128}$/.test(ga4Secret)) {
    errors.ga4_measurement_protocol_secret =
      'Segredo do Measurement Protocol deve ter entre 8 e 128 caracteres alfanuméricos.'
  }

  return errors
}

export function hasCampaignMarketingFieldErrors(errors: CampaignMarketingFieldErrors): boolean {
  return Object.keys(errors).length > 0
}

const MARKETING_FIELD_LABELS: Record<string, string> = {
  fb_pixel: 'Facebook Pixel',
  g_pixel: 'Google Tag Manager',
  gtm_measurement_id: 'ID de medição GA4',
  fb_access_token: 'Token da API de Conversões (CAPI)',
  ga4_measurement_protocol_secret: 'Segredo do Measurement Protocol (GA4)',
}

export function formatCampaignMarketingApiErrors(
  errors?: Record<string, string[]>
): CampaignMarketingFieldErrors {
  if (!errors) return {}

  const mapped: CampaignMarketingFieldErrors = {}
  for (const [key, messages] of Object.entries(errors)) {
    if (!MARKETING_FIELD_LABELS[key] || !Array.isArray(messages) || messages.length === 0) {
      continue
    }
    const field = key as keyof CampaignMarketingFieldErrors
    mapped[field] = messages[0]
  }

  return mapped
}
